import { StarIcon } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";

interface ReviewSummary {
  accuracy: number;
  safety: number;
  cleanliness: number;
  location: number;
  communication: number;
  checkIn: number;
  overallRating: number;
  totalReviews: number;
}

export default function PropertyReviewsSummary({ summary }: { summary: ReviewSummary }) {
  const criteria = [
    { label: "Accuracy", value: summary.accuracy },
    { label: "Safety", value: summary.safety },
    { label: "Cleanliness", value: summary.cleanliness },
    { label: "Location", value: summary.location },
    { label: "Communication", value: summary.communication },
    { label: "Check-in", value: summary.checkIn },
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <StarIcon className="w-5 h-5" />
          <span className="flex items-between">{summary.overallRating.toFixed(1)} · {summary.totalReviews} reviews</span>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {criteria.map((criterion) => (
            <div key={criterion.label} className="flex items-center gap-4">
              <span className="min-w-[100px] text-sm">{criterion.label}</span>
              <Progress value={criterion.value * 20} className="h-2" />
              <span className="text-sm">{criterion.value}</span>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
} 